import { fg } from '@atlassian/jira-feature-gating';

const createProjectFragment = () => `
    project(projectKey: $projectKey) {
        ${!fg('remove-project-id-iviq') ? 'id' : ''}
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;

export default createProjectFragment;
